import createReducer from '../createReducer'
import { CHANGE_AD_UNIT_PATH } from './constants'

export const initialState = { adUnitPaths: [] }

export default createReducer(initialState, {
  [CHANGE_AD_UNIT_PATH]: (state, action) => {
    return { ...state, adUnitPaths: action.payload }
  },
})



// WEBPACK FOOTER //
// ./src/services/ads/reducer.js